import { i18n as i18nType } from 'i18next';
import en from './en';
import pl from './pl';
import ru from './ru';

export const ERROR_NS = 'error';

export const addErrorI18nResources = (i18n: i18nType) => {
  if (!i18n.hasResourceBundle('pl', ERROR_NS)) {
    i18n.addResourceBundle('pl', ERROR_NS, pl);
  }

  if (!i18n.hasResourceBundle('en', ERROR_NS)) {
    i18n.addResourceBundle('en', ERROR_NS, en);
  }

  if (!i18n.hasResourceBundle('ru', ERROR_NS)) {
    i18n.addResourceBundle('ru', ERROR_NS, ru);
  }
};
